
  //  const var_api = 'http://localhost:4500';
  //  const var_api = "https://sage-v2api.suyaptech.com";
//  const var_api = "http://139.59.61.131:4509";
//  const redirect = "http://localhost:3000/signin";




    //  const var_api = "http://188.166.243.155:4502";
     const var_api = "https://live-api.sagebooking.com";
    //  const var_api = 'http://doctorapi.suyaptech.com:5007'



    export { var_api }


    